import { IconNames } from "@blueprintjs/icons";
import React from "react";

import CoreContainer from "core/components/CoreContainer";
import { PanelSetupRequired } from "core/components/editor/EditToggle";
import { IPanelProps, Panel } from "core/decorators/Panel";
import ConfigUtil from "core/util/config/ConfigUtil";
import { nDef } from "core/util/TypeUtils";
import PageConfig from "./PageConfig";

/**
 * @overview: Container type panel with additional configuration to create
 * a page using react-router.
 *
 * @author: jesposito
 */

@Panel({id: "page", configClass: PageConfig})
export default class PagePanel extends React.Component<IPanelProps<PageConfig>, any> {

	public render() {
		const { config } = this.props;

		if(nDef(config) || nDef(config.children) || config.children.length <= 0) {
			return (
				<PanelSetupRequired description="Add some children to get started." />
			);
		}

		return <CoreContainer children={config.children} />;
	}
}



// WEBPACK FOOTER //
// ./src/panels/page/Page.panel.tsx